// extracted by mini-css-extract-plugin
export default {"PieChartContainer":"CustomPieChart_PieChartContainer__oR2bt"};